import { render, staticRenderFns } from "./ManageOrganismDetails.vue?vue&type=template&id=62be3536&scoped=true"
import script from "./ManageOrganismDetails.vue?vue&type=script&lang=js"
export * from "./ManageOrganismDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be3536",
  null
  
)

export default component.exports